import React, { Component } from 'react';
import { toast } from 'react-toastify';

import { ProcesarEstRetiroDir } from "../../funciones/EstudiantesFunction";

class EstRetiroTableAdmin extends Component {
    state = {
        boton: {
            icon: "fa fa-trash",
            text: "Procesar Retiro",
            disabled: false
        },
    }

    procesarRetiro = () => {
        this.setState({
            boton:{
                icon: "fa fa-spinner fa-spin",
                text: "Procesando ...",
                disabled: true
            }
        }, () => {
            ProcesarEstRetiroDir(this.props.data.id, () => {
                this.setState({
                    boton:{
                        icon: "fa fa-trash",
                        text: "Procesar Retiro",
                        disabled: false
                    }
                }, () => {
                    this.props.update();
                    toast.info("Se ha procesado correctamente el retiro del estudiante",{autoClose: 4000}); 
                })
            });
        })
    }

    status = () => {
        let {data} = this.props;
        let {boton} = this.state;

        if(data.status === "2") return (
            <button className="btn btn-primary" disabled = {boton.disabled} onClick = {() => {this.procesarRetiro()}} style={{borderWidth:1}}><i className={boton.icon}></i> {boton.text}</button>
        )

        return (
            <div align = "center">
                <i className="fa fa-check-circle text-success"></i> Procesado
            </div>
        )
    }

    render() { 
        let {data} = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        return (
            <React.Fragment>
            <tr>
                <td style={styles}>
                    <div><strong>{`${data.nacionalidad}${data.ci}`} - <span className="text-danger">{`${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</span></strong></div>
                </td>
                <td style={styles} align = "center">
                    {data.fecha}
                </td>
                <td style={styles}>
                    {this.status()}
                </td>
            </tr>
            </React.Fragment>
        );
    }
}
 
export default EstRetiroTableAdmin;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstRetiroTableAdmin.jsx